var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 614.44 598.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "publicdomainvectors.org",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,41.19,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,83.58,11.5Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,104.77,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,168.36,11.5Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,210.75,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,231.94,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,274.33,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,11.5Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,316.72,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,337.92,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,359.11,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,11.5Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,422.7,11.5Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,11.5a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,443.89,11.5Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,465.09,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,11.5a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,486.28,11.5Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,11.5Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,11.5A9.65,9.65,0,1,1,519,1.85,9.64,9.64,0,0,1,528.67,11.5Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,549.87,11.5Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,11.5a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,571.06,11.5Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,11.5a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,592.26,11.5Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,11.5a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,11.5Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,34.49Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,41.19,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,83.58,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,104.77,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,34.49Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,168.36,34.49Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,210.75,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,231.94,34.49Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,274.33,34.49Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,316.72,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,337.92,34.49Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,359.11,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,422.7,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,34.49a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,443.89,34.49Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,465.09,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,34.49a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,486.28,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,34.49A9.65,9.65,0,1,1,519,24.85,9.64,9.64,0,0,1,528.67,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,549.87,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,34.49a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,571.06,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,34.49a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,592.26,34.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,34.49a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,34.49Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,57.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,57.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,57.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,57.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,57.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,57.49Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,57.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,57.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,57.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,57.49Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,57.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,57.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,57.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,57.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,57.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,57.49Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,57.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,57.49Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,57.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,57.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 57.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,57.49a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,57.49Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,80.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,80.49Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,80.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,80.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,80.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,80.49Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,80.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,80.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,80.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,80.49Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,80.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,80.49Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,80.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,80.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,80.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,80.49Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,80.49a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,80.49Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,80.49a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,80.49Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 80.49,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,80.49a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,80.49Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,41.19,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,103.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,83.58,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,104.77,103.48Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,103.48Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,103.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,168.36,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,103.48Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,210.75,103.48Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,231.94,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,103.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,274.33,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,316.72,103.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,337.92,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,359.11,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,422.7,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,103.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,443.89,103.48Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,465.09,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,103.48a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,486.28,103.48Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,103.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,103.48A9.65,9.65,0,1,1,519,93.84,9.64,9.64,0,0,1,528.67,103.48Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,549.87,103.48Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,103.48a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,571.06,103.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,103.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,592.26,103.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,103.48a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,103.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,126.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,126.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,126.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,126.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,126.48Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,126.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,126.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,126.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,126.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,126.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,126.48a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,126.48a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 126.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,126.48a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,126.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,149.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,149.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,149.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,149.48Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,149.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,149.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,149.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,149.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,149.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,149.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,149.48Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,149.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,149.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 149.48,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,149.48a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,149.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,172.48Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,41.19,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,172.48Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,83.58,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,104.77,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,172.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,168.36,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,210.75,172.48Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,231.94,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,172.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,274.33,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,316.72,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,337.92,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,359.11,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,422.7,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,172.48a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,443.89,172.48Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,465.09,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,172.48a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,486.28,172.48Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,172.48a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,528.67,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,549.87,172.48Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,172.48a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,571.06,172.48Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,172.48a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,592.26,172.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,172.48a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,172.48Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,41.19,195.47Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,195.47Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,83.58,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,104.77,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,195.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,168.36,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,195.47Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,210.75,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,231.94,195.47Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,274.33,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,316.72,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,337.92,195.47Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,359.11,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,195.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,195.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,422.7,195.47Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,195.47a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,443.89,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,465.09,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,195.47a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,486.28,195.47Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,195.47Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,195.47a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,528.67,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,549.87,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,195.47a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,571.06,195.47Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,195.47a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,592.26,195.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,195.47a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,195.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,218.47a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,20,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,218.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,62.38,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,218.47a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,126,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,218.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,147.16,218.47Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,218.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,189.55,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,218.47a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,253.14,218.47Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,218.47a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,295.53,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,218.47a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,380.31,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,218.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,401.5,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,218.47a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,507.48,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 218.47,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,218.47a9.65,9.65,0,1,1-9.64-9.65A9.63,9.63,0,0,1,613.45,218.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,41.19,241.47Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,241.47Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,83.58,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,104.77,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,241.47Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,168.36,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,241.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,210.75,241.47Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,231.94,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,274.33,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,241.47Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,316.72,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,337.92,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,359.11,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,241.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,241.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,422.7,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,241.47a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,443.89,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,465.09,241.47Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,241.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,486.28,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,241.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,528.67,241.47Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,549.87,241.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,241.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,571.06,241.47Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,241.47a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,592.26,241.47Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,241.47a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,241.47Z",
    style: {
      fill: "#005e92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,264.46Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,41.19,264.46Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,83.58,264.46Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,104.77,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,168.36,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.75,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,210.75,264.46Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,231.94,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,264.46Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.33,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,274.33,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,316.72,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,337.92,264.46Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,359.11,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,264.46Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,422.7,264.46Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,264.46a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,443.89,264.46Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.09,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,465.09,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.28,264.46a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,486.28,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,264.46Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,264.46a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,528.67,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.87,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,549.87,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.06,264.46a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,571.06,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.26,264.46a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,592.26,264.46Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,264.46a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,264.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,287.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,287.46Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,287.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,287.46Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,287.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,287.46Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,287.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,287.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,287.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,287.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,287.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,287.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,287.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,287.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,287.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,287.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,287.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,287.46Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,287.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,287.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 287.46,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,287.46a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,287.46Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,310.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,310.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,310.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,310.46Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,310.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,310.46Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,310.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,310.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,310.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,310.46Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,310.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,310.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,310.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,310.46Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,310.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,310.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,310.46a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,310.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,310.46a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,310.46Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 310.46,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,310.46a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,310.46Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,333.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,333.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,333.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,333.45Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,333.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,333.45Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,333.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,333.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,333.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,333.45Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,333.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,333.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,333.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,333.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,333.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,333.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,333.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,333.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,333.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,333.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 333.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,333.45a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,333.45Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,356.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,356.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,356.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,356.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,356.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,356.45Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,356.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,356.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,356.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,356.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,356.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,356.45Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,356.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,356.45Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,356.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,356.45Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,356.45a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,356.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,356.45a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,356.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 356.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,356.45a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,356.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,379.45a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,20,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,379.45a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,62.38,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,379.45a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,126,379.45Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,379.45a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,147.16,379.45Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,379.45a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,189.55,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,379.45a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,253.14,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,379.45a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,295.53,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,379.45a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,380.31,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,379.45a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,401.5,379.45Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,379.45a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,507.48,379.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 379.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,379.45a9.65,9.65,0,1,1-9.64-9.65A9.63,9.63,0,0,1,613.45,379.45Z",
    style: {
      fill: "#008cc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,402.45a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,402.45Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,402.45a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,402.45Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,402.45a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,402.45Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,402.45a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,402.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,402.45a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,402.45Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,402.45a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,402.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,402.45a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,402.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,402.45a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,402.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,402.45a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,402.45Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,402.45a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,402.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 402.45,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,402.45a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,402.45Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,425.44a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,425.44Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-389.77 358.39) rotate(-76.72)",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,425.44a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,425.44Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-357.85 430.84) rotate(-80.86)",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-340.05 451.4) rotate(-80.81)",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,425.44a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,425.44Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,425.44a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,425.44Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-291.02 488.12) rotate(-77.48)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,425.44a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,425.44Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-251 556.02) rotate(-80.81)",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-234.14 574.03) rotate(-80.44)",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,425.44a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,425.44Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-197.57 618.79) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,425.44a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,425.44Z",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-161.95 660.63) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-144.14 681.56) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-126.33 702.48) rotate(-80.81)",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,425.44a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,425.44Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,425.44a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,425.44Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-179.85 416.68) rotate(-45)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-55.08 786.17) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-33.14 812.38) rotate(-81.43)",
    style: {
      fill: "#6ec0eb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-19.46 828.02) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,425.44a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,425.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 425.44,
    r: 9.65,
    transform: "translate(16.16 869.87) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 425.44,
    r: 9.65,
    transform: "translate(-142.61 506.6) rotate(-45)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 425.44,
    r: 9.65,
    transform: "translate(51.78 911.71) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 425.44,
    r: 9.65,
    transform: "translate(69.59 932.63) rotate(-80.81)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,425.44a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,425.44Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,448.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,448.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,448.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,448.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,448.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,448.44Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,448.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,448.44Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,448.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,448.44Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,448.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,448.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,448.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,448.44Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,448.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,448.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,448.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,448.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,448.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,448.44Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 448.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,448.44a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,448.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,471.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,471.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,471.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,471.44Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,471.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,471.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,471.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,471.44Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,471.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,471.44Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,471.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,471.44Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,471.44a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,471.44a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 471.44,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,471.44a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,471.44Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,494.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,494.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-340.38 167.12) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,494.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,494.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-180.75 64.24) rotate(-22.12)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-180.95 73.37) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,494.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,494.43Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,494.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,494.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-285.55 225.57) rotate(-41.02)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,494.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,494.43Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-172.98 113.69) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-183.32 134.78) rotate(-24.23)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,494.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,494.43Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-168.2 137.88) rotate(-22.36)",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,494.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,494.43Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-165.01 154) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-163.42 162.07) rotate(-22.36)",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-161.83 170.13) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,494.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,494.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,494.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,494.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-163.34 782.27) rotate(-76.66)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-155.45 202.39) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-138.51 179.62) rotate(-19.43)",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-152.26 218.51) rotate(-22.36)",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,494.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,494.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-149.08 234.64) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-65.51 906.02) rotate(-76.66)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-145.89 250.77) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 494.43,
    r: 9.65,
    transform: "translate(-144.29 258.83) rotate(-22.36)",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,494.43a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,494.43Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,517.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,517.43Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,517.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,517.43Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,517.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,517.43Z",
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,517.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,517.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,517.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,517.43Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,517.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,517.43Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,517.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,517.43Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,517.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,517.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,517.43a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,517.43Z",
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,517.43a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,517.43Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 517.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,517.43a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,517.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,540.43a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,20,540.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,540.43a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,62.38,540.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,540.43a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,126,540.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,540.43a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,147.16,540.43Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,540.43a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,189.55,540.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#0074ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,540.43a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,253.14,540.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,540.43a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,295.53,540.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,540.43a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,380.31,540.43Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,540.43a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,401.5,540.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,540.43a9.65,9.65,0,1,1-9.65-9.65A9.64,9.64,0,0,1,507.48,540.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 540.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,540.43a9.65,9.65,0,1,1-9.64-9.65A9.63,9.63,0,0,1,613.45,540.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,563.43a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,20,563.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,563.43a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,62.38,563.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,563.43a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,126,563.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,563.43a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,147.16,563.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,563.43a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,189.55,563.43Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,563.43a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,253.14,563.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,563.43a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,295.53,563.43Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,563.43a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,380.31,563.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,563.43a9.65,9.65,0,1,1-9.64-9.65A9.65,9.65,0,0,1,401.5,563.43Z",
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,563.43a9.65,9.65,0,1,1-9.65-9.65A9.65,9.65,0,0,1,507.48,563.43Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 563.43,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,563.43a9.65,9.65,0,1,1-9.64-9.65A9.64,9.64,0,0,1,613.45,563.43Z",
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,586.42a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,20,586.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.54,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.38,586.42a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,62.38,586.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.93,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#e1f4fd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.13,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,586.42a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,126,586.42Z",
    style: {
      fill: "#afd3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,586.42a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,147.16,586.42Z",
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.71,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,586.42a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,189.55,586.42Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.1,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.3,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,586.42a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,253.14,586.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.69,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,586.42a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,295.53,586.42Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.08,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.27,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#c4e9fb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.47,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,586.42a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,380.31,586.42Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5,586.42a9.65,9.65,0,1,1-9.64-9.64A9.65,9.65,0,0,1,401.5,586.42Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.05,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.25,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#8cc7ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.44,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.64,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.48,586.42a9.65,9.65,0,1,1-9.65-9.64A9.65,9.65,0,0,1,507.48,586.42Z",
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 519.03,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#6bbeeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.22,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 561.42,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.61,
    cy: 586.42,
    r: 9.65,
    style: {
      fill: "#26a9e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,586.42a9.65,9.65,0,1,1-9.64-9.64A9.64,9.64,0,0,1,613.45,586.42Z",
    style: {
      fill: "#26a9e0"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.d1c7aa88fe59978db4eefd72e87775f4.svg";
export { ForwardRef as ReactComponent };